export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Tipo de envase',
	plural_model_name_spanish: 'Tipo de envases',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}